// extracted by mini-css-extract-plugin
export default {"form":"Code_form__2+Djn","formTitle":"Code_formTitle__Gdybb","button":"Code_button__D4o+m","field":"Code_field__6pRrr","loader":"Code_loader__-E8yc","hide":"Code_hide__uvrrM"};